import { Folder, FileText, Compass, List } from "lucide-react";
import MetricCard from "./metric-card";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState, useSelector } from "@/core/redux/store";
import { useEffect } from "react";
import { getDashboardStatistics } from "@/core/redux/thunks/dashboardThunk";

export default function TopMetricCards() {
  const { statistics, loadingStatistics } = useSelector(
    (state: RootState) => state.dashboard
  );
  const filterParams = useSelector((state) => state.dashboard.filterParams);
  const dispatch = useDispatch<AppDispatch>();
  const userDetail = useSelector((state) => state.user.me);
  const company = userDetail?.company;
  useEffect(() => {
    if (!company?.id) return;
    dispatch(getDashboardStatistics({ companyId: company.id, ...filterParams }));
  }, [company?.id, filterParams]);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4 w-full mb-[20px] rounded-[16px] overflow-hidden border border-[#e4e4e7]">
      <div className="h-[112px] relative flex flex-col  gap-[20px] py-[20px] bg-white ">
        <MetricCard
          title="Projeler"
          value={statistics?.totalFolders ?? 0}
          icon={<Folder className="size-[16px] text-[#09090b]" />}
          className="lg:border-r lg:border-[#e4e4e7]"
          isLoading={loadingStatistics}
        />
      </div>
      <div className="h-[112px] relative flex flex-col  gap-[20px] py-[20px] bg-white ">
        <MetricCard
          title="Şartnameler"
          value={statistics?.totalSpecifications ?? 0}
          icon={<FileText className="size-[16px] text-[#09090b]" />}
          className="xl:border-r xl:border-[#e4e4e7]"
          isLoading={loadingStatistics}
        />
      </div>
      <div className="h-[112px] relative flex flex-col  gap-[20px] py-[20px] bg-white ">
        <MetricCard
          title="Keşfedilen Ürün"
          value={statistics?.totalProducts ?? 0}
          icon={<Compass className="size-[16px] text-[#09090b]" />}
          className="lg:border-r lg:border-[#e4e4e7]"
          isLoading={loadingStatistics}
        />
      </div>
      <div className="h-[112px] relative flex flex-col  gap-[20px] py-[20px] bg-white ">
        <MetricCard
          title="Cevaplanan Madde"
          value={statistics?.totalAiAnswers ?? 0}
          icon={<List className="size-[16px] text-[#09090b]" />}
          className="xl:border-r xl:border-[#e4e4e7]"
          isLoading={loadingStatistics}
        />
      </div>
    </div>
  );
}
